import api from "@/axios";

export default {
  findAll() {
    return api().get("sponsor");
  },
  findOne(id) {
    return api().get(`admin/sponsor/${id}`);
  },
  create(data) {
    return api().post("admin/sponsor/add", data);
  },
  update(id, data) {
    return api().patch(`admin/sponsor/${id}`, data);
  },
  remove(id) {
    return api().delete(`admin/sponsor/${id}`);
  },
};
